<template>
  <div class="page-container">
    <el-card class="page-content" shadow="never">
      <div class="common_title">
        平仓记录
        <TopPartner @refreshTopPartner="handleSearch"></TopPartner>
      </div>
      <div class="page-actions">
        <div class="select">
          <div class="item">
            <!-- <div class="txt">用户UID</div> -->
            <div class="ipt">
              <el-input
                placeholder="用户UID"
                clearable
                v-model="userId"
                class="userUid_ipt"
              >
                <!-- <img :src="userUid" alt="" slot="prefix" class="userUid" /> -->
              </el-input>
            </div>
          </div>
          <!-- <div class="item">
            <div class="txt">邀请人UID</div>
            <div class="ipt">
              <el-input placeholder="邀请人UID" clearable v-model="inviteBy">
              </el-input>
            </div>
          </div> -->
          <div class="item">
            <!-- <div class="txt">合伙人UID</div> -->
            <div class="ipt">
              <el-input
                placeholder="合伙人UID"
                clearable
                v-model="channelUserId"
                class="userUid_ipt"
              >
                <!-- <img :src="invite" alt="" slot="prefix" class="userUid" /> -->
              </el-input>
            </div>
          </div>
          <div class="item">
            <div class="ipt">
              <el-select v-model="tenantId" placeholder="租户选择" clearable>
                <el-option
                  v-for="item in tenantList"
                  :key="item.id"
                  :label="item.tenantName"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="item">
            <!-- <div class="txt">仓位模式</div> -->
            <div class="ipt">
              <el-select
                @change="changeCoin"
                :rules="[
                  { required: true, message: '请选择', trigger: 'change' },
                ]"
                v-model="positionType"
                placeholder="请选择"
              >
                <el-option label="全部仓位模式" value=""> </el-option>
                <el-option
                  v-for="item in [
                    { id: 1, value: '全仓' },
                    { id: 2, value: '逐仓' },
                  ]"
                  :key="item.id"
                  :label="item.value"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="item">
            <!-- <div class="txt">买卖方向</div> -->
            <div class="ipt">
              <el-select
                @change="changeCoin"
                :rules="[
                  { required: true, message: '请选择', trigger: 'change' },
                ]"
                v-model="orderSide"
                placeholder="请选择"
              >
                <el-option label="全部买卖方向" value=""> </el-option>
                <el-option
                  v-for="item in [
                    { id: 1, value: '买' },
                    { id: 2, value: '卖' },
                  ]"
                  :key="item.id"
                  :label="item.value"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="item">
            <!-- <div class="txt">合约名称</div> -->
            <div class="ipt">
              <el-select
                :rules="[
                  { required: true, message: '请选择', trigger: 'change' },
                ]"
                v-model="symbolId"
                placeholder="请选择"
              >
                <el-option value="" label="全部合约名称"></el-option>
                <el-option
                  v-for="item in symbolList"
                  :key="item.id"
                  :label="item.symbol"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="item">
            <!-- <div class="txt">平仓订单ID</div> -->
            <div class="ipt">
              <el-input placeholder="平仓订单ID" clearable v-model="orderId">
              </el-input>
            </div>
          </div>

          <div class="item">
            <!-- <div class="txt">平仓时间</div> -->
            <div class="ipt">
              <el-date-picker
                v-model="value1"
                type="daterange"
                align="right"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                unlink-panels
                range-separator="-"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                @change="changeTime($event)"
                :picker-options="pickerOptions"
              >
              </el-date-picker>
            </div>
          </div>
          <!-- <div class="item">
            <el-button  @click="searchYesterday">昨日</el-button>
          </div>
          <div class="item">
            <el-button  @click="searchToday">今日</el-button>
          </div> -->
          <div class="item">
            <div class="item-sle">
              <div class="tit">特殊账号</div>
              <el-select
                @change="changeCoin"
                v-model="type"
                placeholder="特殊账号"
              >
                <el-option
                  v-for="item in [
                    { id: 1, value: '隐藏' },
                    { id: 2, value: '显示' },
                  ]"
                  :key="item.id"
                  :label="item.value"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="item">
            <el-button type="primary" @click="handleSearch">查询</el-button>
          </div>
          <div class="item">
            <a @click="getExcel" target="_blank">导出Excel</a>
          </div>
        </div>
      </div>
      <user-list @refresh="refreshList"></user-list>
    </el-card>
    <!-- 添加用户信息弹框 -->
  </div>
</template>

<script>
import "./store";
import UserList from "./components/list";
import { mapState, mapActions, mapMutations } from "vuex";
import { QUERY_TYPE, PAGINATION } from "./constants";
import moment from "moment";
import userUid from "@/assets/input/userUid.png";
import invite from "@/assets/input/invite.png";
import channel from "@/assets/input/channel.png";
import TopPartner from "../topPartner";
import { tenantInfo } from "@/common/publicApi";

export default {
  name: "ClosingCommission",
  components: {
    UserList,
    TopPartner,
  },
  data() {
    return {
      tenantList: [],
      tenantId: "",
      positionType: "",
      orderSide: "",
      invite,
      channel,
      userUid,
      type: 1,
      value2: "",
      dialogVisible: false,
      userId: "",
      orderId: "",
      channelUserId: "",
      symbolId: "",
      value1: "",

      // value1: [
      //   moment(new Date().getTime() - 7 * 1000 * 24 * 60 * 60).format(
      //     'YYYY-MM-DD'
      //   ),
      //   new Date().getFullYear() +
      //     '-' +
      //     (new Date().getMonth() + 1) +
      //     '-' +
      //     new Date().getDate(),
      // ],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
    };
  },
  computed: {
    ...mapState("closingCommission", [
      "queryType",
      "queryTypeList",
      "pagination",
      "coinList",
      "symbolList",
    ]),
    ...mapState(["userInfo"]),
    ...mapState("topPartner", ["topPartner"]),
    // ...mapState('spotassets', ["cionList"]),
  },
  methods: {
    // ...mapActions("spotassets", ["getCoinList"]),
    ...mapActions("closingCommission", [
      "list",
      "getSymbolList",
      "exportExcel",
    ]),
    ...mapMutations("closingCommission", ["setQueryType"]),

    changeCoin() {
      this.list({
        positionType: this.positionType,
        orderSide: this.orderSide,
        channelId: this.topPartner,
        channelUserId: this.channelUserId,
        userId: this.userId,
        orderId: this.orderId,
        symbolId: this.symbolId,
        type: this.type,
        startTime: this.value1 ? this.value1[0] : "",
        endTime: this.value1 ? this.value1[1] : "",
        tenantId: this.tenantId,
        ...PAGINATION,
      });
    },
    refreshList(data = {}) {
      this.list({
        orderId: this.orderId,
        positionType: this.positionType,
        orderSide: this.orderSide,
        symbolId: this.symbolId,
        type: this.type,
        startTime: this.value1 ? this.value1[0] : "",
        endTime: this.value1 ? this.value1[1] : "",
        channelId: this.topPartner,
        channelUserId: this.channelUserId,
        userId: this.userId,
        tenantId: this.tenantId,
        ...this.pagination,
        ...data,
      });
    },
    getExcel() {
      this.exportExcel({
        orderId: this.orderId,
        positionType: this.positionType,
        orderSide: this.orderSide,
        symbolId: this.symbolId,
        type: this.type,
        startTime: this.value1 ? this.value1[0] : "",
        endTime: this.value1 ? this.value1[1] : "",
        channelId: this.topPartner,
        channelUserId: this.channelUserId,
        userId: this.userId,
        tenantId: this.tenantId,
        ...this.pagination,
      }).then((res) => {
        const link = document.createElement("a");
        const blob = new Blob([res], { type: "application/vnd.ms-excel" }); //设置文件流
        link.style.display = "none";
        // 设置连接
        link.href = URL.createObjectURL(blob); //将文件流转化为blob地址
        console.log("link-href", link.href);
        link.download = "平仓记录";
        document.body.appendChild(link);
        // 模拟点击事件
        link.click(); //设置点击事件
      });
    },
    changeTime(e) {
      this.list({
        positionType: this.positionType,
        orderSide: this.orderSide,
        channelId: this.topPartner,
        channelUserId: this.channelUserId,
        userId: this.userId,
        orderId: this.orderId,
        symbolId: this.symbolId,
        type: this.type,
        tenantId: this.tenantId,
        startTime: e[0],
        endTime: e[1],
        ...PAGINATION,
      });
    },
    searchYesterday() {
      this.value1 = [
        moment(new Date().getTime() - 1 * 1000 * 24 * 60 * 60).format(
          "YYYY-MM-DD"
        ),
        moment(new Date().getTime() - 1 * 1000 * 24 * 60 * 60).format(
          "YYYY-MM-DD"
        ),
      ];
      this.handleSearch();
    },
    searchToday() {
      this.value1 = [
        new Date().getFullYear() +
          "-" +
          (new Date().getMonth() + 1) +
          "-" +
          new Date().getDate(),
        new Date().getFullYear() +
          "-" +
          (new Date().getMonth() + 1) +
          "-" +
          new Date().getDate(),
      ];
      this.handleSearch();
    },
    handleSearch() {
      this.list({
        positionType: this.positionType,
        orderSide: this.orderSide,
        channelId: this.topPartner,
        channelUserId: this.channelUserId,
        type: this.type,
        userId: this.userId,
        orderId: this.orderId,
        symbolId: this.symbolId,
        startTime: this.value1 ? this.value1[0] : "",
        endTime: this.value1 ? this.value1[1] : "",
        tenantId: this.tenantId,
        ...PAGINATION,
      });
    },
    handleSave() {},
    closeDialog() {
      this.dialogVisible = false;
    },
    onOpen() {},
    onClose() {
      this.$refs["elForm"].resetFields();
      this.dialogVisible = false;
    },
    close() {
      // this.$emit("update:visible", false);
      this.$refs["elForm"].resetFields();
      this.dialogVisible = false;
    },
  },
  mounted() {
    tenantInfo().then((res) => {
      if (res.code == 0) {
        this.tenantList = res.data;
      }
    });
    this.getSymbolList();
    this.list({
      positionType: this.positionType,
      orderSide: this.orderSide,
      channelId: this.topPartner,
      channelUserId: this.channelUserId,
      type: this.type,
      userId: this.userId,
      orderId: this.orderId,
      symbolId: this.symbolId,
      startTime: this.value1 ? this.value1[0] : "",
      endTime: this.value1 ? this.value1[1] : "",
      tenantId: this.tenantId,
      ...PAGINATION,
    });
  },
};
</script>

<style lang="less" src="../../../styles/button.less" scoped></style>
